/* ============================================================================
   LAH — REPETIR AS LENTES DA ULTIMA COMPRA
   Tema: Testes de implementacao (0.3)

   Cliente logado com pedido anterior de lente E receita ganha um botao acima
   do CTA principal. Ele confere o que sera montado, decide sobre a receita, e
   o fluxo vai direto ao resumo.

   ============================================================================
   O QUE O PAINEL MOSTRA
   ============================================================================
   Armacao desta pagina + lentes do pedido anterior, todas com o PRECO DE HOJE.

   NAO comparamos com o total do pedido antigo: a armacao e outra, entao a
   diferenca nao significaria nada — seria apenas ruido numerico num momento de
   decisao. Desconto, quando existe, aparece: esse sim e informacao util.

   ============================================================================
   AS DUAS OPCOES DE RECEITA — e o que muda entre elas
   ============================================================================
   O FLUXO E O MESMO nos dois casos: monta as lentes e vai direto ao resumo.
   Nenhuma delas passa pela etapa de receita durante a compra.

     MANTER A MESMA  -> os dados do pedido anterior (grau, DP, arquivo) sao
                        gravados neste pedido, sem o cliente preencher nada.

     ENVIAR UMA NOVA -> nada e gravado. Depois da compra o cliente anexa a
                        receita nova na pagina de Receitas da conta dele.

   ============================================================================
   POR QUE A RECEITA E APLICADA NO CARRINHO
   ============================================================================
   O configurador redireciona para o carrinho assim que adiciona, e gravar
   atributos no meio desse caminho e corrida perdida. Guardamos o pacote em
   sessionStorage e lah-repeat-global.js o aplica ja no carrinho.

   A DP NAO e remedida: e medida do rosto, nao do oculos.
   ============================================================================ */

(function () {
    'use strict';

    var STORAGE_RX = 'lah_rx_pendente';

    var dados = document.querySelector('[data-lah-repeat]');
    if (!dados) return;

    var root = document.querySelector('.product-lens-select');
    var cta = document.querySelector('.openProductLens');
    if (!root || !cta) return;

    function parsePares(texto) {
        var out = [];
        (texto || '').split('||').forEach(function (par) {
            if (!par) return;
            var i = par.indexOf('|');
            if (i === -1) return;
            out.push({ chave: par.slice(0, i), valor: par.slice(i + 1) });
        });
        return out;
    }

    var itensAnteriores = parsePares(dados.getAttribute('data-itens'));
    var rxAnterior = parsePares(dados.getAttribute('data-rx'));
    var pedidoNome = dados.getAttribute('data-pedido') || '';
    var pedidoData = dados.getAttribute('data-pedido-data') || '';
    var armacaoNome = dados.getAttribute('data-armacao-nome') || 'Armação';
    var armacaoPreco = parseInt(dados.getAttribute('data-armacao-preco'), 10) || 0;
    var armacaoCompare = parseInt(dados.getAttribute('data-armacao-compare'), 10) || 0;

    if (!itensAnteriores.length) return;

    var escolhaRx = 'manter';

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', {
            style: 'currency', currency: 'BRL'
        });
    }

    function acharOpcaoPorVariante(variantId) {
        var inputs = root.querySelectorAll('input[name="item-variant-id"]');
        for (var i = 0; i < inputs.length; i++) {
            if (inputs[i].value === String(variantId)) {
                var item = inputs[i].closest('.product-lens-select-item');
                if (item) return item;
            }
        }
        return null;
    }

    function valorInput(item, nome) {
        if (!item) return 0;
        var input = item.querySelector('input[name="' + nome + '"]');
        return input ? parseInt(input.value, 10) || 0 : 0;
    }

    /* Levanta o que ainda existe no catalogo e quanto custa hoje */
    function levantar() {
        var disponiveis = [];
        var indisponiveis = [];
        var total = armacaoPreco;
        var economia = 0;

        if (armacaoCompare > armacaoPreco) {
            economia += armacaoCompare - armacaoPreco;
        }

        itensAnteriores.forEach(function (it) {
            var opcao = acharOpcaoPorVariante(it.chave);
            if (!opcao) {
                indisponiveis.push(it.valor);
                return;
            }

            var preco = valorInput(opcao, 'item-variant-price');
            var compare = valorInput(opcao, 'item-variant-compare-price');

            total += preco;
            if (compare > preco) {
                economia += compare - preco;
            }

            disponiveis.push({
                item: opcao,
                nome: opcao.getAttribute('data-item-name') || it.valor,
                preco: preco
            });
        });

        return {
            disponiveis: disponiveis,
            indisponiveis: indisponiveis,
            total: total,
            economia: economia
        };
    }

    /* ---------------------------------------------------------------------
       PAINEL
       --------------------------------------------------------------------- */
    var overlay = null;

    function abrirPainel() {
        var lev = levantar();

        if (!lev.disponiveis.length) {
            var b = document.querySelector('.lah-rp-btn');
            if (b) b.remove();
            return;
        }

        var html = '<div class="lah-rp">' +
            '<button type="button" class="lah-rp__close" aria-label="Fechar" data-rp-fechar>&times;</button>' +
            '<h2 class="lah-rp__title">Repetir as lentes do pedido ' + pedidoNome + '</h2>' +
            '<p class="lah-rp__sub">Compra de ' + pedidoData + '. Veja como fica nesta armação.</p>';

        html += '<div class="lah-rp__row"><span>' + armacaoNome + '</span><span>' +
            moeda(armacaoPreco) + '</span></div>';

        lev.disponiveis.forEach(function (d) {
            html += '<div class="lah-rp__row"><span>' + d.nome + '</span><span>' +
                (d.preco > 0 ? moeda(d.preco) : 'incluso') + '</span></div>';
        });

        if (lev.indisponiveis.length) {
            html += '<div class="lah-rp__aviso"><strong>' + lev.indisponiveis.join(', ') +
                '</strong> não está mais disponível e ficará de fora. ' +
                'Você pode escolher um substituto depois, no próprio fluxo.</div>';
        }

        html += '<div class="lah-rp__precos">' +
            '<div class="lah-rp__preco-linha lah-rp__preco-linha--novo"><span>Total</span>' +
            '<strong>' + moeda(lev.total) + '</strong></div>';

        /* Desconto e a unica comparacao que entra: e ganho concreto. A
           diferenca para o pedido antigo ficou de fora — a armacao e outra,
           entao o numero nao significaria nada. */
        if (lev.economia > 0) {
            html += '<p class="lah-rp__porque">Você economiza <strong>' +
                moeda(lev.economia) + '</strong> com os descontos em vigor.</p>';
        }

        html += '</div>';

        html += '<div class="lah-rp__rx">' +
            '<p class="lah-rp__rx-title">E a sua receita?</p>' +
            '<p class="lah-rp__rx-sub">Temos os dados que você enviou no pedido ' +
            pedidoNome + '.</p>' +

            '<button type="button" class="lah-rp__opt is-on" data-rp-rx="manter">' +
            '<span class="lah-rp__radio"></span><span>' +
            '<span class="lah-rp__opt-title">Manter a mesma receita</span>' +
            '<span class="lah-rp__opt-sub">Aplicamos os dados do pedido anterior neste pedido, ' +
            'sem você preencher nada</span>' +
            '</span></button>' +

            '<button type="button" class="lah-rp__opt" data-rp-rx="nova">' +
            '<span class="lah-rp__radio"></span><span>' +
            '<span class="lah-rp__opt-title">Enviar uma receita nova</span>' +
            '<span class="lah-rp__opt-sub">Depois da compra, você anexa na página ' +
            'de Receitas da sua conta</span>' +
            '</span></button>' +

            '<p class="lah-rp__dp">Sua <strong>DP</strong> continua a mesma nos dois casos: ' +
            'é a medida entre as suas pupilas, não muda com a armação.</p>' +
            '</div>';

        html += '<button type="button" class="lah-rp__cta" data-rp-confirmar>Montar meu pedido</button>' +
            '<p class="lah-rp__foot">Você pode trocar qualquer opção depois de montar.</p>' +
            '</div>';

        overlay = document.createElement('div');
        overlay.className = 'lah-rp-overlay is-open';
        overlay.innerHTML = html;
        document.body.appendChild(overlay);
        document.body.classList.add('hidden-scroll');

        overlay.addEventListener('click', function (event) {
            var t = event.target;

            var opt = t.closest('[data-rp-rx]');
            if (opt) {
                escolhaRx = opt.getAttribute('data-rp-rx');
                Array.prototype.forEach.call(
                    overlay.querySelectorAll('[data-rp-rx]'),
                    function (b) { b.classList.toggle('is-on', b === opt); }
                );
                return;
            }

            if (t.closest('[data-rp-confirmar]')) {
                confirmar(lev);
                return;
            }

            if (t.closest('[data-rp-fechar]') || t === overlay) {
                fechar();
            }
        });

        track('lens_repetir_painel', {
            pedido: pedidoNome,
            itens: lev.disponiveis.length,
            indisponiveis: lev.indisponiveis.length,
            total: lev.total / 100
        });
    }

    function fechar() {
        if (!overlay) return;
        overlay.remove();
        overlay = null;
        document.body.classList.remove('hidden-scroll');
    }

    /* ---------------------------------------------------------------------
       MONTAGEM — lentes e, em seguida, direto ao resumo
       --------------------------------------------------------------------- */
    function clicarSequencia(lista, indice, aoTerminar) {
        if (indice >= lista.length) {
            if (aoTerminar) aoTerminar();
            return;
        }

        var alvo = lista[indice].item;
        var tentativas = 0;

        (function tentar() {
            var etapa = alvo.closest('.product-lens-select-step');
            var visivel = etapa && etapa.offsetParent !== null;

            if (visivel) {
                alvo.click();
                requestAnimationFrame(function () {
                    setTimeout(function () {
                        clicarSequencia(lista, indice + 1, aoTerminar);
                    }, 90);
                });
                return;
            }

            tentativas++;
            if (tentativas > 40) {
                if (aoTerminar) aoTerminar();
                return;
            }

            setTimeout(tentar, 60);
        })();
    }

    /* Depois das lentes, o fluxo pode parar em Acessorios — que nao faz parte
       da "mesma compra de antes". Avancamos com o proprio botao do rodape,
       que e o caminho que o cliente usaria, em vez de forcar o estado.

       Uma passada so: se o rodape nao estiver la, ja estamos no resumo. */
    function irParaResumo() {
        var tentativas = 0;

        (function tentar() {
            var botao = document.querySelector('.lens-footer-button');
            var acessorios = root.querySelector('[data-step-selector="accessories-step"]');
            var naEtapaAcessorios = acessorios && acessorios.offsetParent !== null;

            if (naEtapaAcessorios && botao) {
                botao.click();
                return;
            }

            tentativas++;
            if (tentativas > 25) return;

            setTimeout(tentar, 70);
        })();
    }

    function confirmar(lev) {
        track('lens_repetir_confirmado', {
            pedido: pedidoNome,
            receita: escolhaRx
        });

        /* "Manter": guardamos para gravar no carrinho.
           "Nova": nada acontece na compra — o cliente anexa depois, na conta. */
        if (escolhaRx === 'manter' && rxAnterior.length) {
            try {
                window.sessionStorage.setItem(STORAGE_RX, JSON.stringify({
                    sufixos: rxAnterior,
                    origem: pedidoNome
                }));
            } catch (e) { /* sem storage: segue sem a receita herdada */ }
        }

        fechar();
        cta.click();

        setTimeout(function () {
            clicarSequencia(lev.disponiveis, 0, irParaResumo);
        }, 260);
    }

    /* ---------------------------------------------------------------------
       BOTAO, acima do CTA principal
       --------------------------------------------------------------------- */
    var botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'lah-rp-btn';
    botao.innerHTML =
        '<span class="lah-rp-btn__icon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M4 12a8 8 0 0 1 13-6.2"/><path d="M20 12a8 8 0 0 1-13 6.2"/>' +
        '<path d="M17 3.5v3h-3"/><path d="M7 20.5v-3h3"/></svg></span>' +
        '<span><span class="lah-rp-btn__title">Repetir as lentes da última compra</span>' +
        '<span class="lah-rp-btn__sub">Mesma combinação do pedido ' + pedidoNome + ', nesta armação</span></span>';

    botao.addEventListener('click', abrirPainel);
    cta.parentNode.insertBefore(botao, cta);
})();
